import React from 'react'
import { Redirect, Route, withRouter } from 'react-router-dom'
import { addLocaleData, IntlProvider } from 'react-intl'

import en from 'react-intl/locale-data/en'
import ja from 'react-intl/locale-data/ja'

import messages from '../../messages'
import AppBar from '../AppBar'
import { Background } from './styles'
import Navigation from './Navigation'
import { checkJapanese, flattenMessages } from '../../lib'
import authenticate from '../authenticateHOC'
import config from '../../config/config'
import Maintenace from './Maintenance';
// Language dependencies
addLocaleData([...en, ...ja])

const Back = changeBackground(Background)

const Layout = ({component: Component, ...rest}) => {
  // check if the auth token does not exist in the local or sessionStorage and if not redirect it to login
  let bool = false
  const sessionToken = sessionStorage.getItem('authToken')
  const localToken = localStorage.getItem('authToken')
  if (sessionToken === null && localToken === null) {
    bool = true
  }
  if (bool) {
    return (
      <Redirect
        to={'/login'}
      />
    )
  }

  return (
    <Route
      {...rest}
      render={matchProps => (
        <IntlProvider
          locale={checkJapanese() ? 'ja' : 'en'}
          messages={flattenMessages(
            messages[checkJapanese() ? 'ja' : 'en']
          )}>
          <Back
            location={matchProps.location.pathname}
            className="min-h-inherit w-100 h-100">
            {rest.isCheckingUser ? (
              <div className="min-h-inherit w-100 flex justify-center items-center">
                Loading...
              </div>
            ) : (
              <div>
                 {!config.IS_MAINTENANCE ? <AppBar
                location={matchProps.location.pathname}
                newSeminarUpgradeModal={rest.newSeminarUpgradeModal}
                openSidebar={rest.openSidebar}
                toggleSidebar={rest.toggleSideBar}
                view={rest.view}
                /> : ''}
                {!config.IS_MAINTENANCE ? ( <div className={rest.view === 'desktop' ? 'min-h-inherit w-100 pt3 pr5 pl5' : 'min-h-inherit w-100 p-12 pt-3'}>
                  <div className="w-100 flex">
                    <div style={{height: '85vh'}} className={rest.view === 'desktop' ? 'w-16' : 'w-0'}>
                      <Navigation {...rest} {...matchProps} />
                    </div>
                      <div className={rest.view === 'desktop' ? rest && rest.path === '/admin/room_recordings' ? 'w-80 ml3 room-recording-wrapper' : 'w-80 ml3' : 'w-100'} >
                      <Component
                        {...matchProps}
                      />
                    </div>
                  </div>
                </div>)
                : (
                  <Maintenace />
                )}
              </div>
            )}
          </Back>
        </IntlProvider>
      )}
    />
  )
}

export default withRouter(authenticate(Layout))

/**
 *
 *
 * @param {Object} Component
 * @returns The background as per guest or not
 */
function changeBackground(Component) {
  const BackgroundDiv = props =>
    <Component {...props} />
  return BackgroundDiv
}



// WEBPACK FOOTER //
// src/layouts/LoggedIn/Layout.js